import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Link, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { loginAction, cleanError } from "../redux/actions/login";
import Paper from "@mui/material/Paper";
import CssBaseline from "@mui/material/CssBaseline";
import CustomTextField from "../form/CustomTextField";
import strings from "../i18n/language";
const packageJson = require("../../package.json");

function Login() {
  const dispatch = useDispatch();
  const isDev = process.env.NODE_ENV === "development";
  const [username, setUsername] = useState(isDev ? "sandrascelliazan@gmail.com" : undefined);
  const [password, setPassword] = useState(isDev ? "changeme" : undefined);
  const error = useSelector((state) => state.login.error);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!username || !username.trim()) {
      toast.error(strings.ERROR_ENTER_MAIL);
    } else if (!password || !password.trim()) {
      toast.error(strings.ERROR_ENTER_PASSWORD);
    } else {
      dispatch(loginAction({ email: username, password }));
    }
  };

  useEffect(() => {
    if (error) {
      if (error === "USER_NOT_FOUND") {
        toast.error(strings.ERROR_USER_NOT_FOUND);
      }
      dispatch(cleanError());
    }
  }, [dispatch, error]);
  return (
    <div>
      <ToastContainer position="bottom-right" />
      <Grid
        container
        component="main"
        sx={{ height: "100vh", backgroundColor: "primary.main" }}
      >
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Typography
            sx={{
              color: "#f4edde",
              fontSize: { xs: 40, sm: 60, md: 80 }, // Responsive font size
              fontFamily: "Halu, sans-serif",
              width: "50%",
              textAlign: "center",
            }}
          >
            {strings.MESSAGE_LOGIN}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "secondary.main",
          }}
        >
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{ mt: 1 }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <img
                  src={require("../assets/images/logo_big.png")}
                  alt="Logo"
                  style={{ width: "50%" }}
                />
              </Box>

              <CustomTextField
                margin="normal"
                required
                fullWidth
                variant="filled"
                id="username"
                label={strings.LABEL_MAIL}
                name="username"
                autoComplete="off"
                onChange={setUsername}
                value={username}
                autoFocus
              />
              <CustomTextField
                margin="normal"
                required
                fullWidth
                variant="filled"
                name="password"
                label={strings.LABEL_PASSWORD}
                type="password"
                id="password"
                onChange={setPassword}
                value={password}
                autoComplete="current-password"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                {strings.BUTTON_SIGNIN}
              </Button>
              <div
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  display: "flex",
                }}
              ></div>
            </Box>
          </Box>
          <Typography
            variant="body2"
            align="center"
            style={{ position: "absolute", bottom: 10 }}
          >
            {"Copyright © "}
            <Link color="inherit" href="https://alpes-solutions.com">
              Alpes Solutions
            </Link>{" "}
            {new Date().getFullYear()}
            {"."}
          </Typography>
        </Grid>
      </Grid>
      <div style={{ position: "absolute", bottom: 15, left: 15 }}>
        <Typography variant="body2" color="secondary.main" align="center">
          v{packageJson.version}
        </Typography>
      </div>
    </div>
  );
}

export default Login;
